import type { UniClub as Club } from "../types";

/** Sélectionne uniquement les champs demandés et déclenche le téléchargement du fichier JSON. */
export function exportClubsToJson(clubs: Club[], fileName = "clubs-export.json") {
  // 1) Sélection de champs
  const payload = clubs.map(({ id, nom, lieu, email, site }) => ({
    id, nom, lieu, email: email ?? null, site: site ?? null,
  }));

  // 2) Génération du blob JSON (indenté pour lisibilité)
  const json = JSON.stringify(payload, null, 2);
  const blob = new Blob([json], { type: "application/json;charset=utf-8" });
  const url = URL.createObjectURL(blob);

  // 3) Déclenche le téléchargement
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();

  // 4) Nettoyage
  URL.revokeObjectURL(url);
}
